document.addEventListener('DOMContentLoaded', function () {
    const printPDF = document.getElementById("printPDF");
    const printPDF_toolbar = document.getElementById("printPDF_toolbar");
    const copyUrl = document.getElementsByClassName("copyUrl_clipboard");
    const copyQuelle = document.getElementsByClassName("copyQuelle_clipboard");

    for (i = 0; i < copyUrl.length; i++) {
        if (copyUrl[i] !== null) {
            copyUrl[i].addEventListener('click', function (e) {
                e.preventDefault();
                navigator.clipboard.writeText(window.location.href);

                const copyIcon = this.querySelector('.copy-icon');
                const checkIcon = this.querySelector('.check-icon');

                this.classList.remove('bg-transparent');
                this.classList.add('bg-accent-background');
                copyIcon.classList.add('opacity-0');
                checkIcon.classList.remove('opacity-0');
                checkIcon.classList.add('opacity-100');

                setTimeout(() => {
                    this.classList.add('bg-transparent');
                    this.classList.remove('bg-accent-background');
                    copyIcon.classList.remove('opacity-0');
                    checkIcon.classList.remove('opacity-100');
                    checkIcon.classList.add('opacity-0');
                }, 1500);
            });
        }
    }

    const artikeldetail = document.querySelector(`[id^="artikel_detail_"]`);

    const urlParams = new URLSearchParams(window.location.search);
    const fromParam = urlParams.get('from');

    for (i = 0; i < copyQuelle.length; i++) {
        if (copyQuelle[i] !== null) {
            copyQuelle[i].addEventListener('click', function () {
                let quelle;
                if (artikeldetail.getAttribute("data-heft-issue").includes(fromParam)) {
                    if (document.getElementById("quellenverweis_heft") !== null) {
                        quelle = document.getElementById("quellenverweis_heft").innerText;
                    } else {
                        quelle = document.getElementById("quellenverweis").innerText;
                    }
                } else {
                    quelle = document.getElementById("quellenverweis").innerText;
                }
                navigator.clipboard.writeText(quelle).then(() => {
                    document.dispatchEvent(new CustomEvent('iww:source-reference-copied'));
                });

                const quoteIcon = this.querySelector('.quote-icon');
                const checkIcon = this.querySelector('.check-icon');

                this.classList.remove('text-neutral-subtle', 'hover:text-primary-on-surface');
                this.classList.add('text-primary-on-surface');
                if (quoteIcon && checkIcon) {
                    quoteIcon.classList.add('opacity-0');
                    checkIcon.classList.remove('opacity-0');
                    checkIcon.classList.add('opacity-100');
                }

                setTimeout(() => {
                    this.classList.add('text-neutral-subtle', 'hover:text-primary-on-surface');
                    this.classList.remove('text-primary-on-surface');
                    if (quoteIcon && checkIcon) {
                        quoteIcon.classList.remove('opacity-0');
                        checkIcon.classList.remove('opacity-100');
                        checkIcon.classList.add('opacity-0');
                    }
                }, 1500);
            });
        }
    }

    if (printPDF !== null || printPDF_toolbar !== null) {
        printPDF.addEventListener('click', function () {
            let url = document.getElementById("pdf").getAttribute("href");
            let w = window.open(url);
            w.print();
            w.close();
        });
    }
});
